import { X_HOST } from '@/config/constants';

interface Props {
  // if href starts with '/', it will be prefixed with the X_HOST (parent domain)
  href: string;
  children: React.ReactNode;
}

export const ExtLink: FC<Props> = ({ href, children }) => {
  const url = href.startsWith('/') ? `https://${X_HOST}${href}` : href;
  return (
    <a href={url} rel="nofollow noopener noreferrer" target="_blank">
      {children}
    </a>
  );
};
